<template>
  <header role="banner" class="push page-header">
    <nav class="nav-account" :class="{ 'has-enlarged-logo': userBranding.enlargeLogo }">
      <div class="nav-account__inner">

        <div v-if="shouldApplyUserBrandingToApp && userBranding.logoUrl" class="nav-account__client-logo">
          <img :src="userBranding.logoUrl" :alt="userBranding.companyName">
        </div>

        <span v-else-if="isLoggedIn" class="nav-account__wordmark">
          <span>Energy <i>PriceBook</i></span>
        </span>

        <span v-else class="nav-account__wordmark">
          <a href="/" class="non-app-link">Energy <i>PriceBook</i></a>
        </span>

        <i class="nav-icon"></i>

        <div class="nav-account__options" v-if="isRegistered">
          <ul class="nav-account__list">
            <li class="nav-account__item">
              <a href="/account" class="non-app-link">{{ userName }}</a>
            </li>  
            <li class="nav-account__item">
              <a href="#"
                @click.stop.prevent="toggleViewMenu"
              ><div class="nav-account__user-icon"><i class="fa fa-user-circle"></i></div></a>

              <ul class="nav-account__submenu"
                :class="{ 'nav-account__submenu--show': viewMenu }"
              >

                <template v-if="showViewToggle">
                  <li class="nav-account__subitem" 
                    :class="{ 'nav-account__subitem--current': isWorkspace }"
                  >
                    <a href="#" @click.prevent="setView('workspace')">All-in Workspace</a>
                  </li>
                  <li class="nav-account__subitem"
                    :class="{ 'nav-account__subitem--current': !isWorkspace }"
                  >
                    <a href="#" @click.prevent="setView('dashboard-warn')">All-in Dashboard</a>
                  </li>
                </template>

                <li class="nav-account__subitem" v-if="hasProductAccess('epm')">
                  <a href="/energy-price-monitor">Energy Price Monitor</a>
                </li>
                <li class="nav-account__subitem" v-if="hasProductAccess('pprSettings')">
                  <a href="/account/pricing-reports/settings">PPR Settings</a>
                </li>
                <li class="nav-account__subitem">
                  <a href="/account" class="non-app-link">My Account</a>
                </li>
                <li class="nav-account__subitem">
                  <a href="/auth/logout" class="non-app-link">Logout</a>
                </li>
              </ul>
            </li>
          </ul>
        </div><!--/.nav-account__options-->

        <div class="nav-account__options" v-else>
          <ul class="nav-account__list">     
            <li class="nav-account__item"><a href="/about" class="non-app-link">About</a></li>
            <li class="nav-account__item"><a href="#" role="button" @click="openMarketingVideoModal">Why EPB</a></li>
            <li class="nav-account__item"><a href="/solutions" class="non-app-link">Solutions</a></li>
            <li class="nav-account__item"><a href="/subscribe" class="non-app-link">Subscribe</a></li>
            <li class="nav-account__item"><a href="/contact" class="non-app-link">Contact</a></li>
            <li class="nav-account__item">
              <a href="/auth" class="non-app-link">Login</a>
            </li>
            <li class="nav-account__item">
              <a href="/" class="non-app-link">Home</a>
            </li>
          </ul>
        </div>
      </div><!--/.nav-account__inner-->
    </nav>
  </header> 
</template>

<script>
import _ from 'lodash'
import swal from 'sweetalert'
import { formatCurrency, formatNumber } from '../../common/helpers'

export default {
  data() {
    return {
      collapsedNav: false,
      viewMenu: false,
    }
  },
  computed: {
    userName() {
      return this.$store.getters.userName
    },
    userPlan() {
      return this.$store.getters.userPlan
    },
    planConfig() {
      return this.$store.getters.planConfig
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    isRegistered() {
      return this.$store.getters.regStatus
    },
    currentPricingRequest() {
      return this.$store.getters.currentPricingRequest
    },
    lastLoadedPricingRequest() {
      return this.$store.getters.lastLoadedPricingRequest
    },
    isWorkspace() {
      if (this.$store.getters.view === 'workspace') {
        return true
      }
      return false
    },
    showViewToggle() {
      return this.planConfig.priceRequestSlots && 
        this.planConfig.priceRequestSlots > 0 &&
        this.hasProductAccess('apm')
    },
    collapseButtonText() {
      if (this.collapsedNav) {
        return 'Unhide'
      }
      return 'Hide'
    },
    pricingRequestHasBeenEdited() {
      return !_.isEqual(this.currentPricingRequest, this.lastLoadedPricingRequest)
    },
    utility() {
      if (this.currentPricingRequest.utilityMeta.name && this.currentPricingRequest.utilityMeta.code) {
        let utility = this.currentPricingRequest.utilityMeta.name + ' - ' + this.currentPricingRequest.utilityMeta.code
        if (this.currentPricingRequest.utilityMeta.municipality || this.currentPricingRequest.utilityMeta.zone) {
          utility += '<br>'

          if (this.currentPricingRequest.utilityMeta.municipality) {
            utility += this.currentPricingRequest.utilityMeta.municipality + ', ' + this.currentPricingRequest.utilityMeta.state + ' '
          }

          if (this.currentPricingRequest.utilityMeta.zone) {
            utility += '(Zone ' + this.currentPricingRequest.utilityMeta.zone + ')'
          }

          return utility
        }
      } 

      return false
    },
    startMonth() {
      if (this.currentPricingRequest.startMonth) {
        return moment(this.currentPricingRequest.startMonth).format('MMM YYYY')
      }
      return false
    },
    termLength() {
      return this.$store.getters.termLength
    },
    activeTerms() {
      var activeTerms = this.termLength
      activeTerms = activeTerms.filter(function(item) {
        return item.value != ''
      })
      return activeTerms
    },
    activeTermLengthCount() {
      // The number of terms set in the store
      return Object.keys(this.activeTerms).length
    },
    termLengths() {
      if (this.activeTermLengthCount < 1) {
        return false
      }

      let displayText = ''

      switch(this.activeTermLengthCount) {
        case 1: 
          displayText = this.activeTerms[0].value
          break;
        case 2:
          displayText = this.activeTerms[0].value + ' & ' + this.activeTerms[1].value
          break;
        case 3:
          displayText = this.activeTerms[0].value + ', ' + this.activeTerms[1].value + ', & ' + this.activeTerms[2].value
          break;
      }

      let lastTerm = displayText+''
      lastTerm = lastTerm.split(" ")

      if (lastTerm[lastTerm.length - 1] === '1') {
        displayText += ' Month'
      } else {
        displayText += ' Months'
      }

      return displayText
    },
    facilityCategory() {
      if (this.facilityTree) {
        return this.facilityTree[0]
      }
      return false
    },
    facilityTree() {
      if (this.currentPricingRequest.facilityType.parents) {
        let parents = this.currentPricingRequest.facilityType.parents.slice()
        parents = parents.reverse()
        return parents
      }
      return false     
    },
    customFacilityProfile() {
      let count =  Object.keys(this.currentPricingRequest.customFacilityProfile).length
      return count > 0
    },
    volume() {
      if (!this.currentPricingRequest.volume.amount) {      
        return false
      }

      let volume = ''

      switch(this.currentPricingRequest.volume.unit) {
        case 'usage':
          volume = formatNumber(this.currentPricingRequest.volume.amount, 0) + " kWh/Yr"
          break

        case 'total-cost':
          volume = formatCurrency(this.currentPricingRequest.volume.amount, 0) + "/Yr"
          break

        case 'annual-peak':
          volume = formatNumber(this.currentPricingRequest.volume.amount, 0) + " KW"
          break
      }

      return volume
    },
    customFacilityVolume() {
      if (this.currentPricingRequest.customFacilityVolume.terms && this.currentPricingRequest.customFacilityVolume.terms.length) {
        return this.currentPricingRequest.customFacilityVolume
      }
      return false
    },
    volumeComplete() {
      if (this.volume || this.customFacilityVolume) {

        if (this.declineBrokerFee) {
          return true

        } else if (this.currentPricingRequest.volume.brokerFee || this.currentPricingRequest.customFacilityVolume.brokerFee) {
          return true
        }
      }
      return false
    },
    declineBrokerFee() {
      return this.$store.getters.declineBrokerFee
    },
    shouldApplyUserBrandingToApp() {
      return this.$store.getters.shouldApplyUserBrandingToApp
    },
    userBranding() {
      return this.$store.getters.userBranding
    },
  },
  methods: {
    hasProductAccess(product) {
      const productAccess = this.$store.getters.userProductAccess
      return productAccess[product]
    },
    toggleViewMenu() {
      this.viewMenu = !this.viewMenu
    },
    hideViewMenu() {
      this.viewMenu = false
    },
    setView(view) {
      this.$store.dispatch('setView', view)
      this.hideViewMenu()
    },
    openMarketingVideoModal() {
      let iframe = document.querySelector('#modal-marketing-video iframe'),
          player = new Vimeo.Player(iframe),
          modal = document.querySelector('#modal-marketing-video')

          modal.classList.add('active')
          player.play()

      document.querySelector('#modal-video-close').addEventListener('click', () => {
        modal.classList.remove('active')
        player.pause()
      })

      player.on('ended', () => {
        modal.classList.remove('active')
      })
    }
  },
  created() {
    document.addEventListener('click', () => {
      this.hideViewMenu()
    })
  }
}
</script>
